(function ()
{
  var myVar = setInterval(timer, 500);
  function timer() {
    if (window.jQuery) {
      $(document).ready(function () {
        if ((window.location.href.indexOf("rewards") > -1) || (window.location.href.indexOf("refer") > -1)) {
          $("body").addClass("swell-rewards");
        }
      });
      stop();
    }
  }
  function stop() {
    clearInterval(myVar);
  }
}).call(this);
